<micro-select-combo #sel
              placeholder="Project"
              [mode]="mode"
              [(id)]="taskProjectId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="isDisabled()"
              [requires]="requires()"
              platformService="taskd"
>
</micro-select-combo>
